/** @jsxImportSource @emotion/react */

import { FC, useMemo } from "react";
import Row from "../../../../components/Grid/Row";
import Column from "../../../../components/Grid/Column";
import useDocumentDetails from "../../../../hooks/useDocumentDetails";
import ProviderButton from "./ProviderButton";
import Typography from "../../../../components/Typography";
import { ColorNames } from "../../../../theme";
import { ResultStatus } from "../../../../graphql/__GENERATED__/types";

interface SelectProviderProps {
  onClick: (resultId: string) => void;
}

const SelectProvider: FC<SelectProviderProps> = ({ onClick }) => {
  const {
    selectedResultId,
    documentData: { selectedSimulationResults },
  } = useDocumentDetails();

  const approvedResult = useMemo(() => {
    return selectedSimulationResults?.find(
      (result) => result?.status === ResultStatus.Approved
    );
  }, [selectedSimulationResults]);

  return (
    <>
      <Row>
        <Column>
          <Typography
            variant="textExtraLarge"
            uppercase
            color={ColorNames.GREEN}
            component="p"
            align="left"
          >
            Qual <strong>seguro</strong> deseja contratar?
          </Typography>
          <Typography
            variant="textMedium"
            component="p"
            align="left"
            margin="sm"
          >
            Selecione uma das seguradoras abaixo
          </Typography>
        </Column>
      </Row>
      <Row>
        {selectedSimulationResults?.map((result, i) => (
          <Column xs={12} md={4}>
            <ProviderButton
              key={`quotationCard-${i}`}
              result={result!}
              active={selectedResultId === result!._id}
              onClick={() => onClick(result!._id!)}
              disabled={!!approvedResult}
            />
          </Column>
        ))}
      </Row>
    </>
  );
};

export default SelectProvider;
